import { Link } from "react-router-dom";
import { GraduationCap, Building2, ArrowRight } from "lucide-react";
import "./audience.css";

import jobSeekerPhoto from "../../../assets/job-seeker pic.webp";
import careerCenterPhoto from "../../../assets/career-center-home.webp";

const audiences = [
  {
    label: "For job seekers",
    tone: "blue",
    to: "/job-seekers",
    icon: GraduationCap,
    image: jobSeekerPhoto,
    alt: "A student working through applications on a laptop in a campus library",
  },
  {
    label: "For career centers",
    tone: "teal",
    to: "/career-centers",
    icon: Building2,
    image: careerCenterPhoto,
    alt: "Students and advisors working together in a campus career center",
  },
];

const Audience = () => (
  <section className="home-audience">
    <div className="home-container">
      <div className="home-audience-head">
        <h2 className="home-section-title home-audience-title">
          Built for both sides of{" "}
          <br className="br-wide" />
          the job&nbsp;search
        </h2>
        <p className="home-lead home-audience-sub">
          Whether you&rsquo;re chasing your first offer or running the office that
          helps thousands of students get theirs, see how RAIN fits the way you
          work.
        </p>
      </div>

      <div className="home-audience-cards">
        {audiences.map(({ label, tone, to, icon: Icon, image, alt }) => (
          <Link key={label} to={to} className={`home-audience-card home-audience-${tone}`}>
            <div className="home-audience-photo">
              <img decoding="async" src={image} alt={alt} loading="lazy" />
            </div>
            <div className="home-audience-card-foot">
              <span className="home-audience-badge">
                <Icon size={16} strokeWidth={1.75} />
              </span>
              <span className="home-audience-label">{label}</span>
              <ArrowRight size={20} strokeWidth={1.75} className="home-audience-arrow" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default Audience;
